import React from 'react'
import FooterWidgetComponent from '../../widgets/FooterWidget/FooterWidgetComponent'
import PocketBannerComponent from './widget/PocketBanner/PocketBannerComponent'
import SectionAComponent from './widget/SectionA/SectionAComponent'

function Pocket() {
  return (
    <div>
        <PocketBannerComponent/>
        <SectionAComponent/>
        <FooterWidgetComponent/>
    </div>
  )
}

export default Pocket